export const GOOGLE_FONT_LINK_TAG_ID = 'atrivial-style-overrides-google-fonts';
export const FONT_FACE_STYLE_TAG_ID = 'atrivial-style-overrides-font-faces';
export const FONT_RESOURCE_STATE_ATTRIBUTE = 'data-atrivial-font-resource-state';

/** Waits until the selected remote stylesheet is registered in the CSSOM. */
export function waitForStyleOverrideFontResources(): Promise<void> {
  if (typeof document === 'undefined') return Promise.resolve();
  const link = document.getElementById(GOOGLE_FONT_LINK_TAG_ID);
  if (!link) return Promise.resolve();

  const state = link.getAttribute(FONT_RESOURCE_STATE_ATTRIBUTE);
  if (state === 'ready') return Promise.resolve();
  if (state === 'failed') return Promise.reject(new Error('Selected font stylesheet failed'));

  return new Promise((resolve, reject) => {
    link.addEventListener('load', () => resolve(), { once: true });
    link.addEventListener('error', () => reject(new Error('Selected font stylesheet failed')), {
      once: true,
    });
  });
}
